export default "__VITE_ASSET__808b5218__"